import React from 'react';
import ViewWrapper from '../../common/comoponents/view-wrapper';
import View from './view';

class CnPieChart extends ViewWrapper<React.ComponentProps<typeof View>> {
  constructor(props: React.ComponentProps<typeof View>) {
    super(props);

    this.ref = React.createRef();
  }

  render() {
    return <View {...this.props} ref={this.ref} />;
  }
}

CnPieChart.displayName = View.displayName;

export default CnPieChart;
